import axios, { AxiosPromise } from 'axios';
import { IUserToken } from '../../../@types/model/auth/userToken/userToken';

export default class AuthHttpService {
    public static signUp = (employeeNumber : string, password : string) : AxiosPromise<IUserToken> => {
        return axios.post(`${API_URL}/v1/Rights/Authorisation/SignUp`, {
            employeeNumber,
            password,
        }, {
            auth: {
                username: BASIC_USER,
                password: BASIC_PASSWORD,
            },
        });
    }

    public static googleLogIn = (code : string) : AxiosPromise<IUserToken> => {
        return axios.post(`${API_URL}/v1/Rights/Authorisation/LogInGoogle`, {
            code,
        }, {
            auth: {
                username: BASIC_USER,
                password: BASIC_PASSWORD,
            },
        });
    }

    public static logIn = (username : string, password : string) : AxiosPromise<IUserToken> => {
        return axios.post(`${API_URL}/v1/Rights/Authorisation/LogIn`, {
            emailOrUsername: username,
            password,
        }, {
            auth: {
                username: BASIC_USER,
                password: BASIC_PASSWORD,
            },
        });
    }

    public static refreshSession = () : AxiosPromise<IUserToken> => {
        return axios.get(`${API_URL}/v1/Rights/Authorisation/GetSession`);
    }

    public static logout = () : AxiosPromise => {
        return axios.get(`${API_URL}/v1/Rights/Authorisation/Logout`);
    }

    public static logoutUsers = async (userIds : Array<number>) : Promise<void> => {
        await axios.post(`${API_URL}/v1/Rights/Authorisation/LogoutUsers`, userIds);
    }
}
